import { formatDateTime } from '../../utils/dataFormatter';
import { DATE_TIME_TYPES } from '../../constants/dataTimeTypes';
import {
    NO_VOUCHERS_FOUND_MESSAGE,
    NO_VOUCHERS_FOUND_FOR_STATUS_MESSAGE,
    NO_VOUCHERS_FOUND_FOR_GREETLY_ID_MESSAGE,
    NO_VOUCHERS_FOUND_FOR_VOUCHER_ID_MESSAGE,
    NO_VOUCHERS_FOUND_BETWEEN_DATES_MESSAGE,
    SEARCH_KEY_GREETLY_ID,
    SEARCH_KEY_VOUCHER_ID,
    SEARCH_KEY_THEME_NAME,
    SEARCH_KEY_BATCH_ID,
    SEARCH_KEY_STORE,
    SUB_SEARCH_KEY_LOCATION,
    THYAGA_GREETLY_TOPUP_URL,
    THYAGA_CHECK_BALANCE_URL,
} from './greetlyVouchersConstants';

// Build label object from voucher data for printing
export const buildLabelObject = (data) => {
    return {
        id: data.voucher.id,
        ownerName: data.voucher.receiverName || data.voucher.ownerName,
        sender: data.voucher.senderName || data.sender,
        amount: data.voucher.amount,
        purchaseId: data.voucher.purchaseId || data.purchaseId,
    };
};

// Build checked row object from voucher data
export const buildCheckedRowObject = (data) => {
    return {
        greetlyId: data.greetlyId,
        voucherId: data.voucher.id,
    };
};

// Generate not found message for search results
export const getSearchNotFoundMessage = (searchKey, id, subSearchKey, subId) => {
    // if (searchKey === '' && id === 'greetlyId') {
    //     return 'No vouchers found between entered dates';
    // }
    if (subSearchKey === SUB_SEARCH_KEY_LOCATION && subId) {
        return `No vouchers found for Location : ${subId}`;
    }
    if (searchKey === SEARCH_KEY_GREETLY_ID && id) {
        return `${NO_VOUCHERS_FOUND_FOR_GREETLY_ID_MESSAGE} : ${id}`;
    }
    if (searchKey === SEARCH_KEY_VOUCHER_ID && id) {
        return `${NO_VOUCHERS_FOUND_FOR_VOUCHER_ID_MESSAGE} : ${id}`;
    }
    if (searchKey === SEARCH_KEY_THEME_NAME && id) {
        return `No vouchers found for Theme : ${id}`;
    }
    if (searchKey === SEARCH_KEY_BATCH_ID && id) {
        return `No vouchers found for Batch ID : ${id}`;
    }
    if (searchKey === SEARCH_KEY_STORE && id) {
        return `No vouchers found for Store : ${id}`;
    }

    return 'No Vouchers found';
};

// Generate not found message for status filter
export const getStatusFilterNotFoundMessage = (statusItems, statusKey) => {
    if (statusKey !== 'ALL') {
        const status = statusItems.filter((item) => item.key === statusKey);
        return `${NO_VOUCHERS_FOUND_FOR_STATUS_MESSAGE} : ${status[0].label}`;
    }
    return NO_VOUCHERS_FOUND_MESSAGE;
};

// Generate not found message for date filter
export const getDateFilterNotFoundMessage = (startDate, endDate) => {
    const startStr = formatDateTime(startDate, DATE_TIME_TYPES.DATE);
    const endStr = formatDateTime(endDate, DATE_TIME_TYPES.DATE);
    return `${NO_VOUCHERS_FOUND_BETWEEN_DATES_MESSAGE} ${startStr} - ${endStr}`;
};

// Move a picked end date to 11:59:59 PM so that whole day is included
export const toEndOfDay = (date) => {
    if (!date) return null;
    const endOfDay = new Date(date);
    endOfDay.setHours(23, 59, 59, 999);
    return endOfDay;
};

// Generate ZPL code for printing QR codes
export const generateZPLCodes = (checkedRows) => {
    let zpl = '';

    checkedRows.forEach((obj) => {
        zpl += `^XA
^MD22
^PW799
^LL799
^CI28

# ----- LEFT QR (same X as your 3-QR layout) -----
^FO38,6^BQN,2,6^FDQA,${THYAGA_GREETLY_TOPUP_URL}/${obj.greetlyId}^FS
^FO70,220^A0N,28,28^FD${obj.greetlyId}^FS

# ----- RIGHT QR (use the 3-QR middle position: 302px) -----
^FO302,6^BQN,2,6^FDQA,${THYAGA_CHECK_BALANCE_URL}/${obj.voucherId}^FS
^FO334,220^A0N,28,28^FD${obj.voucherId}^FS

^XZ`;
    });

    return zpl;
};

// Check if a row is already in the checked rows array
export const findCheckedRowIndex = (checkedRows, greetlyId) => {
    return checkedRows.findIndex((c) => c.greetlyId === greetlyId);
};

// Find voucher data by greetly ID
export const findVoucherByGreetlyId = (voucherData, greetlyId) => {
    return voucherData.find((v) => v.greetlyId === greetlyId);
};

// Deduplicate checked rows and labels by ID
export const deduplicateItems = (items, keyName) => {
    return Array.from(new Map(items.map((item) => [item[keyName], item])).values());
};

// Filter out items by a set of IDs
export const filterOutByIds = (items, idsToExclude, keyName) => {
    return items.filter((item) => !idsToExclude.has(item[keyName]));
};
